<template>
  <section :class="classes" :id="`uuid-${model.uuid}`" :ref="`id-${model.uuid}`">
    <div class="cards-wrapper section__container">
      <div :class="mgnlLayout">
        <slot :cell="'large-5'">

        </slot>
      </div>
    </div>
  </section>
</template>

<script>
import { mgnlComponentMixin } from "@wl-vue-mixins/mixins.js";
import router from '@wl-vue-utils/router.js'

export default {
  mixins: [mgnlComponentMixin], // !!! all the mgnl components must be configured with mgnlComponentMixin !!!
  router: router,
  name: "CardsWrapper",
  data() {
    return {}
  },

  computed: {
    classes() {
      return [
        "section",
        this.model.sectionStyle ? "section--" + this.model.sectionStyle : ''
      ];
    },
    mgnlLayout(){
      const currentURL = this.$route?.fullPath;
      const layoutClass = `cards-wrapper-container__${this.model.layoutSelect}`;
      return currentURL.includes('mgnlPreview') ? `${layoutClass} mgnlOverflow` : layoutClass;
    }
  },
};
</script>